export default "__VITE_ASSET__B2QJCvvP__"